import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  postRequest } from '../api/api';
import { BaseUrl } from '../api/env';

// Async thunks


export const createMessage = createAsyncThunk(
  'message/create',
  async ({newMessage}, { rejectWithValue }) => {
    try {
    //  console.log(`${BaseUrl}/postmessage`);
      const response = await postRequest(`${BaseUrl}/postmessage`,  newMessage);
    //  console.log(response);
      return response;
      
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);





// Slice
const messageSlice = createSlice({
  name: 'message',
  initialState: {
    messages: null,
    status: null, // loading, succeeded, failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearMessagesStatus: (state) => {
      state.status = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // Create class
      .addCase(createMessage.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(createMessage.fulfilled, (state, action) => {
        state.status = 'succeeded';
       // state.messages.push(action.payload.data);
        state.error = null;
      })
      .addCase(createMessage.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  }

});

// Export actions
export const { clearError , clearMessagesStatus } = messageSlice.actions;

// Export reducer
export default messageSlice.reducer;

export const selectMessages = (state) => state.message.messages;

export const selectMessagesStatus = (state) => state.message.status;

